const thwiftyImages = [
  {
    link: "/store/deals",
    image: "https://cdn.ebtida.com/1772919847075-Banner.jpg",
  },
  {
    link: "/search/refurbished",
    image: "https://cdn.ebtida.com/1772919847075-Banner2.jpg",
  },
];

const domain = "rockmycart.com";
const domainName = "rockmycart";
const domainLogo = "https://cdn.ebtida.com/1772809179969-rockmycart.png";
const bgColor = "#000";
const favicon = "https://cdn.ebtida.com/1773000246024-Favicon(1).png";
const email = "help@rockmycart.com";
const metaTitle = "Rockmycart: Your One-Stop Shop for Affordable Deals and Quality Products";
const metaDescription =
  "RockMyCart is a UAE-based e-commerce platform offering rock bottom deals on electronics, fashion, gadgets, accessories and more. Built to make online shopping fast, exciting, and affordable.";
const headerBg = "#000";
const subMenu = "#000";
const bannesImages = thwiftyImages;
const buttonColor = "#f7f7f7";
const address =
  "Compass Building<br />FDCW1862, Al Shohada Road<br /> Al Hamra Industrial Zone-FZ<br />Ras Al Khaimah, United Arab Emirates";
const phone = "+971 4 836 9553, +971 4 836 9557";

const Host = {
  domain: domain,
  domainName: domainName,
  domainLogo: domainLogo,
  bgColor: bgColor,
  favicon: favicon,
  email: email,
  metaTitle: metaTitle,
  metaDescription: metaDescription,
  headerBg: headerBg,
  subMenu: subMenu,
  bannesImages: bannesImages,
  buttonColor: buttonColor,
  address: address,
  phone: phone,
};

export default Host;
